<template>
  <v-container fluid>
      <v-layout align-center justify-center>
              <div class="pendingan">
                  <v-img class="pendingan" max-width="650" src="http://icon.irmastore.id/menunggu-approval.png"/>
                  <h2>Sedang dalam tahap pengembangan</h2>
              </div>
      </v-layout>
  </v-container>

</template>

<script>
  export default {
      name: "SedangMenunggu"
  }
</script>

<style scoped>
.pendingan {
  padding: 10px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  text-align: center;
}
</style>
